import ReactPlayer from 'react-player';
import ch1_img1 from 'assets/knowledge/ch1_img1.png';
import ch1_img2 from 'assets/knowledge/ch1_img2.png';
import ch1_img3 from 'assets/knowledge/ch1_img3.png';
import ch1_img4 from 'assets/knowledge/ch1_img4.png';
import ch1_img5 from 'assets/knowledge/ch1_img5.png';
import ch1_img6 from 'assets/knowledge/ch1_img6.png';
import ch1_img7 from 'assets/knowledge/ch1_img7.png';
import ch1_img8 from 'assets/knowledge/ch1_img8.png';



const Chapter1 = () => {
  return <div>
  <h2>Kurze Einführung</h2>
  <ReactPlayer url="https://youtu.be/9OCczvhUOpE" controls width="100%" />
  <h3>1. CO2OPT - Eine kurze Einführung</h3>
  <p>CO2OPT modernisiert den eigenen Fuhrpark, indem alle relevanten Daten der Fahrzeuge zentral
    gesammelt und verwaltet werden. Aufgrund der Auswertung von Telematikdaten können für das jeweilige
    Einsatzgebiet der Fahrzeuge passgenaue und unabhängige Reifenempfehlungen ausgesprochen werden.
    Dadurch reduzieren sich langfristig der Kraftstoffverbrauch und die eigenen CO₂-Emissionen um bis zu 10 Prozent.</p>
  <img src={ch1_img1} alt="CO2OPT Übersicht" />
  <h3>2. Das Dashboard</h3>
  <p>Wir beginnen unseren Rundgang mit dem Dashboard der Software.
    Hier erhält man eine Übersicht zu den wichtigsten Themen. Dazu gehören selbstverständlich die hinterlegten Fahrzeuge sowie Reifen.

In der Fahrzeugübersicht kann man der Konfiguration jederzeit auf eine der Kacheln klicken
und sich somit anzeigen lassen, welche Fahrzeuge bereits vollständig konfiguriert sind, nur
teilweise konfiguriert sind oder noch gänzlich neu konfiguriert werden müssen.
</p>
  <img src={ch1_img2} alt="Dashboard Ansicht" />

<p>Die Reifenübersicht zeigt einem ebenfalls per einfachem Mausklick, welche Reifen sich bereits im Einsatz befinden,
  welche Reifen eine Profiltiefe von weniger als 3 mm aufweisen, welcher Reifen über eine Profiltiefe von 3 bis
  5 mm verfügen und welche Reifen in voraussichtlich weniger als drei Monaten ausgetauscht werden sollten.

Im nächsten Bereich kann man die Hochrechnung zum eigenen Einsparpotenzial hinsichtlich der Gesamtkosten, CO₂-Emissionen und Kraftstoffkosten. Für eine detaillierte Auswertung reicht ein Klick auf die Schaltfläche „Siehe Mehr“.
</p>

<img src={ch1_img3} alt="Flottenübersicht3" />
<p>Die Kachel rechts daneben zeigt dir die letzten Aktivitäten innerhalb des Fuhrparks an. Per
Klick auf die Schaltfläche oben rechts kann man diese Liste auch ausklappen und so komfortabel die letzten Ereignisse prüfen.
</p>
<img src={ch1_img4} alt="Flottenübersicht4" />
<p>Herzstück der Software ist selbstverständlich der Bereich Reifenempfehlungen.
Je Fahrzeug können anhand der Telematikdaten wichtige Informationen zum Einsatzgebiet,
dem Fahrverhalten und mehr ausgewertet werden. Hieraus resultiert ein Vorschlag zum optimalen Reifen
für die jeweilige Achse des Fahrzeugs. In den Einstellungen, welche über die Schaltfläche „anpassen“
zu finden sind, können auch einzelne Schwerpunkte wie Preis oder Laufleistung aktiviert oder deaktiviert werden.
Ebenso lassen sich einzelne Marken direkt ausschließen oder zwingend für die Auswahl aktivieren. Die Empfehlungen
seitens CO2OPT sind zu 100 % unabhängig und richten sich ausschließlich nach den Auswertungen der eigenen
Fahrzeug- und Telematikdaten.
</p>
<img src={ch1_img5} alt="Flottenübersicht5" />
<p>Abschließend erscheint im Dashboad noch eine Liste der aktuell offenen Aufgaben.
In diesem Fallbeispiel verfügt ein Reifen über eine geringere Profiltiefe als 3 mm und
sollte daher zeitnah ausgetauscht werden.
</p>
<img src={ch1_img6} alt="Flottenübersicht6" />
<h3>3. Die Flotte</h3>

<p>Die Flotte gibt Dir stets einen Überblick über sämtliche Fuhrparks und angelegten Fahrzeuge
inklusive der wichtigsten Eckdaten. Es können beliebig viele Fuhrparks angelegt und ebenso
beliebig viele Fahrzeuge hinzugefügt werden.

Möchte man eine größere Anzahl an LKW oder Anhängern hinzufügen, klickt man auf die
jeweilige Schaltfläche „LKW / Anhänger hinzufügen“ und danach auf den Reiter „Mehreren“.
Es können nun Tabellen im CSV- oder Excel-Format heruntergeladen werden. Diese sind mit
entsprechenden Beispieldaten befüllt. Wenn eure eigene Fahrzeugliste im gleichen Format
eingepflegt wird, erkennt das System die wichtigsten Daten automatisch und erstellt binnen weniger
Sekunden ein digitales Abbild eurer LKW oder Trailer.

</p>
<img src={ch1_img7} alt="Flottenübersicht7" />

<p>
Per Klick auf eines der Fahrzeuge gelangt man in die jeweilige Detailansicht. Im oberen Bereich erkennt man die Fahrzeugart, den Hersteller, das Kennzeichnen, die Fahrzeugidentifikationsnummer, die Flotte, eine vollständige Konfigurierung des Fahrzeugs und die erfolgreiche Anbindung an die Telematik. Über die Schaltfläche rechts kann man auch einzelne Mitarbeiter hinsichtlich der Zuständigkeit des Fahrzeugs zuweisen.
</p>
<p>
Der nächste Abschnitt gibt einem Hinweise zur internen Gruppierung, den jeweiligen Reifengrößen, Stand des Kilometerzählers, Tankinhalt, der Achsenkonfiguration und optional auch den nächsten Terminen für Inspektion und Sicherheitscheck. In der rechten Kachel können Zugmaschinen auch fest mit bestimmten Trailern verbunden werden, wenn dies gewünscht sein sollte.
</p>
<p>
Die Reifenkonfiguration zeigt einem alle derzeit montierten Reifen eines Fahrzeugs inklusive aller relevanten Informationen zum Reifen selbst auf. Hierzu gehören vor allem die Reifennummer, die Profiltiefe, Druck, Marke und Modell.
</p>
<p>
Im Reiter Fahrzeugdatei kann man Bilder und Dokumente für das jeweilige Fahrzeug hinzufügen. Dies könnten beispielsweise Werkstattberichte bezüglich notwendiger Reifenwechsel sein. Hier kann man auch COC-Dokumente hochladen.
</p>
<p>
Die Nutzungsberichte geben einem bedarfsweise täglich oder wöchentlich Informationen zum Missionsprofil und weitere Eckdaten, welche für die automatische Fahrzeugauswertung und somit auch für die Reifenempfehlungen relevant sind. Diese können selbstverständlich auch heruntergeladen werden.
</p>
<p>
Im letzten Reiter gibt es erneut die Möglichkeit, eure jeweiligen Reifenempfehlungen anzusehen und diese auch nach den eigenen Kriterien individuell anzupassen.
</p>
<img src = {ch1_img8} alt="Flottenübersicht8" />

</div>
};

export default Chapter1;